import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import styles from './styles/EnergyManagement.module.scss';

import { OmaLummeApp } from '../../../omaLummeContext';

import Box from '../../Common/Box';
import Button from '../../Common/Button';
import { Contract } from '../../../types/contract';

export const contractIsEnergyManagement = (contract: Contract) => {
  /**
   * 184/176: EnergyManagementFull
   * 185/177: EnergyManagementLite
   * 250/222: EnergyManagementWithBatteries
   */
  const tariffs = import.meta.env.VITE_ENV === 'dev' ? [184, 185, 250] : [176, 177, 222];

  return contract.activeDeliveries ? contract.activeDeliveries.filter((d) => tariffs.includes(d.tariffNo)).length > 0 : false;
};

export const EnergyManagement: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { users, contracts, selectedMeteringPointContract } = OmaLummeApp.useState();

  React.useEffect(() => {
    if (
      !contracts?.find((c) => contractIsEnergyManagement(c)) &&
      selectedMeteringPointContract &&
      !contractIsEnergyManagement(selectedMeteringPointContract)
    ) {
      navigate('/');
    }
  }, [contracts, selectedMeteringPointContract]);

  const activeUserIsOwner = users.activeUser.userId === users.parentUser.userId;

  return (
    <>
      <Box>
        <h1>{t(`manageContracts:energyManagement.homeTitle`)}</h1>
        <p className={styles.description}>{t(`manageContracts:energyManagement.homeDescription`)}</p>

        {activeUserIsOwner && (
          <div className={styles.button}>
            <Button
              link={
                import.meta.env.VITE_ENV === 'dev'
                  ? 'https://dev.sunergos.lol/app/partners/lumme'
                  : import.meta.env.VITE_ENV === 'stg'
                    ? 'https://app.stg.enion.fi/app/partners/lumme'
                    : 'https://app.enion.fi/app/partners/lumme'
              }
              newTab
            >
              {t(`manageContracts:energyManagement.portalLink`)}
            </Button>
          </div>
        )}
        {!activeUserIsOwner && <p>{t(`manageContracts:energyManagement.portalOnlyForOwners`)}</p>}
      </Box>
    </>
  );
};

export default EnergyManagement;
